export default __webpack_public_path__ + "static/media/feedback.341d7662.png";